<template lang="pug">
  div.map-context.map-context-object-menu.map-marker-actions
    ul
      li(@click.prevent.stop="createRelation()") Создать связь
      template(v-if="isTkoObject")
        li(v-if="isActive===true" @click.prevent.stop="editOrOpenObject()") Открыть карточку объекта
        li(v-else @click.prevent.stop="editOrOpenObject()") Редактировать карточку объекта
        template(v-if="canRestore")
          li(
          v-if="isRemoved"
          @click.prevent.stop="restoreItem()"
          ) Восстановить объект
          li(
          v-else
          @click.prevent.stop="deleteItem()"
          ) Удалить объект
</template>

<script>
  import permissionMixin from '../../../mixins/permission-mixin.js'
  import mapContextMixin from '../mixins/map-context-mixin.js'
  import RelationPopup from '../utils/popup/RelationPopup.js'
  import {tko, map as mapEndpoints} from '../../../api/api-endpoints.js'
  import url from '../../../utils/url.js'
  import {STATUS_ACTIVE} from '../../../config/config.js'
  import {POPUP_AUTO_PAN, POPUP_KEEP_IN_VIEW} from '../../../config/map.js'
  import {OBJECT} from '../../../utils/map/types.js'
  import {PERMS} from '../../../config/permissions.js'

  export default {
    name: 'map-context-object-menu',
    mixins: [mapContextMixin, permissionMixin],
    computed: {
      isTkoObject () {
        if (this.model && this.model.type === OBJECT.TKO) {
          return true
        }
        return false
      },
      isRemoved () {
        return this.model.thread_del
      },
      isActive () {
        if (this.model && this.model.status_id == STATUS_ACTIVE) {
          return true
        }
        return false
      },
      canRestore () {
        return this.model && this.model.threads_tko_object_id
      }
    },
    methods: {
      restoreItem () {
        this.closeMenu()
        if (this.userHavePermissionEx(PERMS.EDIT) === false) {
          return false
        }

        this.$bar.start()
        this.$sharedServices.store.dispatch('updateModel', {
          url: tko.objectDeleteRestore(this.model.id)
        }).then(r => {
          this.onSuccess(r)
        }).catch(erResponse => {
          this.$e.errorBox(erResponse)
          this.$bar.finish()
        })
      },
      createRelation () {
        /* if (this.userHavePermissionEx(PERMS.CREATE) === false) {
          return false
        } */

        this.popup = new RelationPopup({
          autoPan: POPUP_AUTO_PAN,
          keepInView: POPUP_KEEP_IN_VIEW,
          minWidth: 700,
          minHeight: 1000,
          model: this.model,
          opts: {
            vm: this
          }
        })
        this.layer.bindPopup(this.popup).openPopup()
        this.closeMenu()
      },
      editOrOpenObject () {
        let name = 'geo.forecasts.object.update'
        let params = {
          id: (this.model.tko_object_id || this.model.id)
        }
        let query = {}
        query.prevRoute = url.getRoute(this.$sharedServices.router.history.current, true)
        let route = {
          name: name,
          params: params,
          query: query
        }
        /* let permType = this.isActive ? PERMS.VIEW : PERMS.EDIT
        if (this.userHavePermissionEx(permType, route) === false) {
          return false
        } */

        // for disable reload data on map
        console.log('skipAsyncData src/app/geo/components/map-context-object-menu.vue')
        this.$sharedServices.store.commit('skipAsyncData', {
          name: name,
          value: true
        })

        this.closeMenu()

        this.$sharedServices.router.push(route)
      },
      deleteWithRestorePossibility () {
        this.$e.confirmBox(
          'Вы сможете восстановить данный объект',
          'Удалить объект?'
        ).then(() => {
          this.$bar.start()
          // delete with restore
          this.$sharedServices.store.dispatch('updateModel', {
            url: tko.objectDeleteLogical(this.model.id)
          }).then(r => {
            this.onSuccess(r)
          }).catch(erResponse => {
            this.$e.errorBox(erResponse)
            this.$bar.finish()
          })
        })
      },
      deleteItem () {
        this.closeMenu()
        if (this.userHavePermissionEx(PERMS.DELETE) === false) {
          return false
        }

        if (this.canRestore) {
          this.deleteWithRestorePossibility()
        }
      },
      onSuccess (r) {
        this.$bar.finish()
        // after succes, full map data reload
        this.$emitter.emit('geo.mapUpdate', {
          component: 'map-context-object-menu',
          action: 'delete',
          response: r
        })
      }
    }
  }
</script>

